<template>
  <v-menu
    ref="filter_menu"
    :attach="'#components'"
    :close-on-content-click="false"
    content-class="filters-menu"
    offset-y
    @input="input">
    <template #activator="{ on, value, attrs }">
      <sBadge
        color="red"
        data-qa="filter-block-badge"
        dot
        :offset-x="8"
        :offset-y="5"
        overlap
        :value="filters_count">
        <div v-on="on">
          <sButton
            v-bind="attrs"
            :class="[{'open': value}, 'filters-menu__btn px-2 py-1']"
            :color="value ? '#718e8c' : 'var(--black-color)'"
            data-qa="btn-open-filter"
            icon="filter"
            small
            type="text"/>
        </div>
      </sBadge>
    </template>
    <div
      class="filters-menu__list">
      <div
        v-if="!computed_filters.length"
        class="grey--text h6-text empty text-start pb-4">
        {{ $t('Planning.EpmtyFilters') }}
      </div>
      <div
        v-else
        v-for="(filter, n) in computed_filters"
        :key="filter.id"
        :class="{'filters-template secondary__green_chosen rounded-lg px-3 pt-2 ': filter.filterJson}"
        :data-qa="(filter.filterJson ? 'filters-template-': 'filter-') + n ">
        <div
          v-if="filter.filterName"
          class="mb-2 h7-text-medium text-start"
          data-qa="filters-template-name">
          {{ filter.filterName }}
        </div>
        <FilterRow
          v-for="(item, i) in filter.filters || [filter]"
          :key="item.id"
          class="pb-3"
          :elem="filter.filters ? filter.filters[i] : filter "
          :items="filterByUsed(item)"
          :mode.sync="mode"
          :num="n + i + (n && active_template && computed_filters[0].filters && computed_filters[0].filters.length > 1 ? 1 : 0)"
          with-mode
          @cancel="cancel(item)"
          @change-type="(new_val, old) => changeType(new_val, old, filter.filters || computed_filters, filter.filters ? i : n)">
          <template #activator="{ disabled }">
            <slot
              :disabled="disabled"
              :item="item"
              name="third_activator"/>
          </template>
        </FilterRow>
      </div>
      <div class="flex mt-2 align-center">
        <sButton
          v-if="filterByUsed().length"
          class="px-2"
          data-qa="btn-add-filter"
          icon="plus"
          icon-size="8px"
          small
          type="text"
          @click="addFilter">
          {{ $t('Common.Add').toUpperCase() }}
        </sButton>
        <div
          class="ml-auto">
          <v-menu
            v-if="can_save_template || filters_templates.length"
            content-class="menu"
            max-height="400px"
            offset-y
            right>
            <template #activator="{ on, value }">
              <div
                data-qa="open-menu"
                v-on="on">
                <sButton
                  class="px-2"
                  data-qa="btn-saved-filters"
                  small
                  type="text">
                  {{ $t('Common.Filters.SavedFilters') }}
                  <sIcon
                    class="ml-2 my-auto"
                    :rotate="value ? '-180' : '0'"
                    size="10"
                    type="arrow"/>
                </sButton>
              </div>
            </template>
            <div
              :key="filters_templates.length"
              class="filter-list"
              data-qa="saved-filters-template-list"
              dense>
              <div
                v-for="(item) in filters_templates "
                :key="item.id"
                class="filter-list__item"
                :class="{'active-template' : active_template == item.id}"
                :data-qa="'saved-filters-template-' + item.id"
                :value="item.id"
                @click="selectTemplate(item)">
                <div
                  class="filter-list__item-title"
                  data-qa="filters-template-name">
                  {{ item.filterName }}
                </div>
                <div
                  class="filter-list__item-action">
                  <FiltersTemplateDialog
                    :delete-filter-template="deleteTemplate"
                    :item="item">
                    <template #item="{ item: template, disabled }">
                      <slot
                        :disabled="disabled"
                        :item="template"
                        name="third_activator"/>
                    </template>
                  </FiltersTemplateDialog>
                </div>
              </div>
              <sDivider
                v-if="filters_templates.length && can_save_template"
                class="ma-2"/>
              <FiltersTemplateDialog
                v-if="can_save_template"
                :add-template="addTemplate"
                :filters="computed_filters"
                :mode="mode">
                <template #item="{ item, disabled }">
                  <slot
                    :disabled="disabled"
                    :item="item"
                    name="third_activator"/>
                </template>
              </FiltersTemplateDialog>
            </div>
          </v-menu>
        </div>
      </div>
    </div>
  </v-menu>
</template>

<script>
import FilterRow from 'components/common/elements/FilterRow.vue'
import FiltersTemplateDialog from 'components/common/dialogs/FiltersTemplateDialog.vue'

import { filtersTemplatesMixin, storageMixin } from 'mixins'

export default {
  name: 'filtersBlock',
  mixins: [ storageMixin, filtersTemplatesMixin ],
  data() {
    return {
      computed_filters: [],
      filters: {
        filters: [],
        filters_mode: true,
      },
      key: 0,
      menu: false,
      mode: true,
      active_template: null,
      filters_count: ''
    }
  },
  props: {
    /**
     * доступні види фільтрів
     */
    available_types: {
      type: Array,
      default: () => []
    },
  },
  async mounted() {
    //this.$root.$on('deleteAllTags', this.clearAll)
    //this.$root.$on('deleteTag', this.deleteTag)
    this.$root.$on('updateFilters', this.updateFilters)
    this.$root.$on('deleteFilterTemplate', this.deleteFilter)
  },
  async beforeDestroy() {
    //this.$root.$off('deleteAllTags', this.clearAll)
    //this.$root.$off('deleteTag', this.deleteTag)
    this.$root.$off('updateFilters', this.updateFilters)
    this.$root.$off('deleteFilterTemplate', this.deleteFilter)
  },
  computed: {
    can_save_template() {
      if  (!this.filters_type) {
        return ''
      }
      let length = this.computed_filters?.length
      return length >= 1 && (!this.active_template || this.computed_filters?.some(el => !el.filters)) && this.checkValues(this.computed_filters)?.length == length
    },
    store_filters: {
      get() {
        if (this.filters_type) {
          let filters_templates = this.$store.getters.getFilters || {}
          return filters_templates[this.filters_type] || []
        }
        return []
      },
      set(val) {
        if (this.filters_type) {
          this.$store.commit('setFilters', val)
        }
      }
    },
    filters_templates: {
      get() {
        if (this.filters_type) {
          let filters_templates = this.$store.getters.getFiltersTemplatesByType || {}
          return  filters_templates[this.filters_type] || []
        }
        return []
      },
      set(val) {
        if (this.filters_type) {
          this.$store.commit('setFiltersTemplatesByType', val)
        }
      }
    },
  },
  methods: {
    filterByUsed(item) {
      return this.available_types.filter(elem => {
        return (item && item.id == elem.id)
          || !this.computed_filters?.some(el => el.id == elem.id || el.filters?.some(it => it.id == elem.id))
      })
    },
    selectTemplate(template) {
      if (this.active_template != template.id) {
        this.updateFilters({ template })
      }
      this.active_template = template.id
    },
    /**
     * @param {Object} update  объект {
     *   filters_mode,
     *   template, Приходит по click на пункте меню
     *   filters,
     *   not_updade,
     *   current,
     *   change_template  прилетает при изменении фильтра из FiltersTemplateDialog
     * }
      */
    updateFilters(update) {
      if (update?.filters?.length) {
        update.filters = update.filters.filter((obj, index, self) =>
          index === self.findIndex((t) => (
            t.id === obj.id
          ))
        )
      }

      let filters = []
      let check_is_template = (template, template_filters) => {
        let parsed = template && template.filterJson && JSON.parse(template?.filterJson)

        if (!template || (parsed && !this.$_.isEqual(parsed, { filters: template_filters, mode: update.filters_mode }))) {
          filters = this.getFilters(filters).filters
          this.active_template = null
          this.$root.$emit('updateFiltersTepmlate', null)
        } else if (template) {
          this.active_template = template.id
          return template.id
        }
      }
      let getTemplate = () => {
        return filters.find(el => el.filters && this.filters_templates.some(it => it.id == el.id))
      }
      if (update.change_template) {
        let arr = this.$_.cloneDeep(this.computed_filters),
          template = arr.find(el => el.id == update.change_template.id)
        if (template) {
          template.filterName = update.change_template.filterName
          this.updateFilters({ filters: arr, not_updade: true })
        }
        return
      } else if (update.template) {
        filters = this.mapTemplates([update.template], this.store_filters.checkActualFilters)

        update.filters_mode = filters[0].mode ?? this.mode
        check_is_template(update.template, filters[0].filters)
      } else if (update.filters) {
        update.filters_mode = update.filters_mode ?? this.mode
        filters = this.mapTemplates(this.$_.cloneDeep(update.filters))

        let template = getTemplate()
        let template_id = check_is_template(template, template?.filters)

        if (template_id) {
          this.$root.$emit('updateFiltersTepmlate', template.id)
        }
      } else if (Object.keys(update).includes('filters_mode')) {
        filters = this.mapTemplates(this.$_.cloneDeep(this.computed_filters))
        let template = filters.find(el => el.filters)
        check_is_template(template, filters)
      }
      update.filters_mode = update.filters_mode ?? true

      this.key = (Math.max(...filters.map(el =>  el.key || 0)))

      let condition = (array) =>  this.$_.differenceWith(filters , this.mapTemplates(array || []), this.$_.isEqual).length
        || filters.length != array?.length
        || update.filters_mode != this.filters?.filters_mode

      if (!update.current || condition(this.computed_filters)) {
        this.computed_filters = this.$_.cloneDeep(filters).map((el) => {
          if (!el.key) {
            this.key = this.key + 1
            el.key = this.key
          }
          return el
        })
      }

      filters = this.checkValues(filters).map(el => {
        delete el.key
        return el
      })

      if (condition(this.filters?.filters) && !update.not_updade) {
        this.$emit('applyFilters', this.$_.cloneDeep(filters), update.filters_mode)

        this.$root.$emit('loadData', {
          filters: this.getFilters(this.$_.cloneDeep(filters)).filters,
          filters_mode: update.filters_mode,
        })
        if (!filters?.length) {
          this.$root.$emit('updateFiltersTepmlate', null)
        }
      } else if (update.not_updade) {
        this.$_saveFiltersToDBStorage({filters, filters_mode: update.filters_mode})
      }
      this.filters = {
        filters: this.$_.cloneDeep(filters),
        filters_mode: update.filters_mode,
      }
      this.filters_count = filters.reduce((tot, filt) => tot += filt?.filters?.length || 1, 0)
    },
    checkValues(filters, check_empty) {
      let checkValue = (elem) =>  elem.value || (elem.search ? elem.search?.length : elem.value)

      return filters.filter(el => {
        let has_val = checkValue(el) || el.filters?.some(elem => checkValue(elem))
        return check_empty ? !has_val : has_val
      })
    },
    addFilter() {
      let filter = this.$_.cloneDeep(this.filterByUsed()[0])
      this.computed_filters.push({
        id: filter.id,
        title: filter.title,
        contain: true,
        search: [],
        type: filter.type,
      })
    },
    cancel(item) {
      this.$emit('cancel', item)
      this.computed_filters = this.computed_filters.filter(el => {
        if (el.filterJson && el.filters) {
          el.filters = el.filters.filter(it => it?.id != item?.id)
          return el.filters.length
        } else {
          return el?.id != item?.id
        }
      })
    },
    changeType(new_item, old_elem, arr, i) {
      this.$set(arr, i, this.$_.cloneDeep(new_item))
    },
    addTemplate(template) {
      this.active_template = template.id
      this.updateFilters({template})
    },
    deleteTemplate() {
      this.updateFilters({ filters: this.computed_filters, current: true })
    },
    deleteFilter(param) {
      if (param && this.computed_filters) {
        const computedFilters = this.computed_filters.find(el => el.id === param.id)
        if (computedFilters) { this.computed_filters = computedFilters.filters }
      }
    },
    input(val) {
      this.$emit('change-state', val)
      if (!val && this.computed_filters?.some(el => !el.search?.length && !el.filterJson)) {
        this.computed_filters = this.computed_filters.filter(el => el.search?.length || el.filterJson)
      }
    }
  },
  watch: {
    computed_filters: {
      handler(val) {
        this.updateFilters({ filters: val, current: true })
      },
      deep: true
    },
    mode: {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.updateFilters({filters_mode: val, current: true})
        }
      },
    }
  },
  components: {
    FilterRow,
    FiltersTemplateDialog
  }
}
</script>
<style lang="scss" scoped>
.active-template {
  background-color: var(--v-secondary__green_chosen-base) ;
}
.filters-menu {
  &__badge-chip {
    height: 20px !important;
  }
  &__list {
    padding: 24px;
    background-color: var(--v-main__light_green-base);
    border: 2px solid var(--white-color);
  }
}
.empty {
  width: 350px;
}
.filters-group  {
  border-radius: 8px;
  overflow: auto;
}
.filter-list {
  background: var(--v-main__light_green-base);
  color: var(--black-color);
  display: block;
  padding: 8px 0;
  position: static;
  font-weight: 500;
  border-color: var(--white-color);
  &__item {
    $item: &;
    cursor: pointer;
    padding: 0 16px;
    flex: 1 1 100%;
    min-height: 35px;
    align-items: center;
    display: flex;
    &-title {
      text-align: start;
      font-size: 13px;
    }
    &-action {
      display: none;
      position: absolute;
      right: 5px;
      background: var(--v-main__light_green-base);
    }
    &:hover,
    &:focus {
      #{$item}-action {
        display: block;
      }
    }

    &.active-template {
      #{$item}-action {
        background: var(--v-secondary__green_chosen-base);
      }
    }
  }
}
</style>
<style lang="scss">
.filters-menu__badge {
  margin: auto 6px auto 0;
  &.s-badge__badge {
    height: 20px;
    padding: 0;
    z-index: 2;
  }
}
</style>
